import { REGISTRATION_STEPS, RegistrationSortBy } from "@is/constants";
import { Device, Step, Store } from "@is/types";

import { ViewStateContainer } from "./ViewStateContext";

export type RegistrationViewState = {
  activeStepIndex: number;
  steps: Step[];
  selectedStore?: Store;
  device?: Device;
  deviceName?: string;
  searchTerm?: string;
  country?: string;
  sortBy: RegistrationSortBy;
  page: number;
};

export type RegistrationViewStateContainer =
  ViewStateContainer<RegistrationViewState>;

export const initialRegistrationViewState: RegistrationViewState = {
  activeStepIndex: 0,
  steps: REGISTRATION_STEPS,
  selectedStore: null,
  device: null,
  deviceName: "",
  country: null,
  searchTerm: "",
  page: 1,
  sortBy: RegistrationSortBy.StoreId,
};
